import React from 'react';
import { motion } from 'framer-motion';
import { Badge } from './Badge';
export interface TabItem {
  id: string;
  label: string;
  count?: number;
}
interface TabsProps {
  tabs: TabItem[];
  activeTab: string;
  onChange: (id: string) => void;
  className?: string;
}
export const Tabs: React.FC<TabsProps> = ({
  tabs,
  activeTab,
  onChange,
  className = ''
}) => {
  return <div className={`border-b border-border-light ${className}`} data-id="element-235">
      <nav className="-mb-px flex space-x-8" aria-label="Tabs" data-id="element-236">
        {tabs.map(tab => {
        const isActive = activeTab === tab.id;
        return <button key={tab.id} onClick={() => onChange(tab.id)} className={`
                relative whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors
                ${isActive ? 'border-transparent text-fpg-navy' : 'border-transparent text-text-secondary hover:text-text-primary hover:border-border-default'}
              `} aria-current={isActive ? 'page' : undefined} data-id="element-237">
              <div className="flex items-center gap-2" data-id="element-238">
                {tab.label}
                {tab.count !== undefined && <Badge variant={isActive ? 'default' : 'neutral'} size="sm" data-id="element-239">
                    {tab.count}
                  </Badge>}
              </div>
              {isActive && <motion.div layoutId="activeTabIndicator" className="absolute bottom-[-2px] left-0 right-0 h-0.5 bg-fpg-navy" initial={false} transition={{
            type: 'spring',
            stiffness: 500,
            damping: 30
          }} data-id="element-240" />}
            </button>;
      })}
      </nav>
    </div>;
};